import { render, staticRenderFns } from "./page-animation-library.vue?vue&type=template&id=50e49170&scoped=true"
import script from "./page-animation-library.vue?vue&type=script&lang=ts"
export * from "./page-animation-library.vue?vue&type=script&lang=ts"
import style0 from "./page-animation-library.vue?vue&type=style&index=0&id=50e49170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e49170",
  null
  
)

export default component.exports